module.exports = __webpack_public_path__ + "img/doc_f.b4b9485e.png";